// components/BlogPostDetail.jsx
import React, { useState } from "react";
import {
  Card,
  Typography,
  Divider,
  Space,
  Tag,
  Button,
  Modal,
  message,
} from "antd";
import {
  CalendarOutlined,
  UserOutlined,
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import Like from "./Like/Like";
import { useAuth } from "../hooks/useBlogAPI";

const { Title, Paragraph } = Typography;

const BlogPostDetail = ({ post, onEdit, onDelete }) => {
  const { user } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleProtectedAction = (actionName) => {
    if (!user) {
      setShowAuthModal(true);
      return false;
    }
    return true;
  };

  const handleGoToLogin = () => {
    window.location.href = "/auth";
    setShowAuthModal(false);
  };

  const handleCancel = () => {
    setShowAuthModal(false);
  };

  // 检查当前用户是否为文章作者
  const isAuthor = user && post && user.id === post.authorId;

  return (
    <>
      <Card
        title={
          <div>
            <Title level={2} style={{ marginBottom: 0 }}>
              {post.title}
            </Title>
            <Space size="large" style={{ marginTop: 16 }}>
              <span>
                <UserOutlined /> {post.author}
              </span>
              <span>
                <CalendarOutlined />{" "}
                {new Date(post.publishedDate).toLocaleString()}
              </span>
              <span>
                <EyeOutlined /> {post.views || 0} 阅读
              </span>
              <span>
                <Like post={post} />
              </span>
            </Space>
          </div>
        }
        extra={
          <Space>
            {isAuthor ? (
              <>
                <Button icon={<EditOutlined />} onClick={onEdit}>
                  编辑
                </Button>
                <Button icon={<DeleteOutlined />} danger onClick={onDelete}>
                  删除
                </Button>
              </>
            ) : (
              <>
                <Button
                  icon={<EditOutlined />}
                  onClick={() => handleProtectedAction("编辑")}
                  disabled={!user}
                >
                  编辑
                </Button>
                <Button
                  icon={<DeleteOutlined />}
                  danger
                  onClick={() => handleProtectedAction("删除")}
                  disabled={!user}
                >
                  删除
                </Button>
              </>
            )}
          </Space>
        }
      >
        {post.tags &&
          post.tags.map((tag) => (
            <Tag color="blue" key={tag}>
              {tag}
            </Tag>
          ))}

        <Divider />

        <Paragraph style={{ fontSize: 16, lineHeight: 1.8 }}>
          {post.content}
        </Paragraph>
      </Card>

      {/* 未登录提示模态框 */}
      <Modal
        title="需要登录"
        open={showAuthModal}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            取消
          </Button>,
          <Button key="login" type="primary" onClick={handleGoToLogin}>
            去登录
          </Button>,
        ]}
      >
        <p>您需要先登录才能执行此操作。</p>
      </Modal>
    </>
  );
};

export default BlogPostDetail;
